// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__T1jgr","column":"style_column__16ceI","row":"style_row__JLdcu"};